import React from 'react'


const Loader = () => (
    <div className="lds-roller"><div></div><div></div><div></div><div></div></div>
)

export default Loader